// src/api/montages.api.ts — SCE Issues
// Lecture et écriture des montages sous-traités (29/10) : bloc `montages` de la
// ligne `__global__` de SCE_UserPrefs, à côté de la liste en fabrication.
// Aucune colonne SharePoint. Règles et format : `utils/montages`.

import { lireBlocGlobal, modifierBlocGlobal } from './reglagesGlobaux.api'
import { CLE_BLOC_MONTAGES, attribuer, lireMontages, type MetierMontage, type Montages } from '@/utils/montages'

export async function lireMontagesEnregistres(): Promise<Montages> {
  return lireMontages(await lireBlocGlobal(CLE_BLOC_MONTAGES))
}

/**
 * Confie le montage de ces équipements, sur le bloc RELU à l'instant : deux
 * coordinateurs qui attribuent en même temps ne s'effacent pas.
 */
export async function enregistrerAttribution(
  numerosSerie: readonly string[],
  metier: MetierMontage,
  valeur: string | null,
  par: string,
): Promise<Montages> {
  let resultat: Montages | null = null
  await modifierBlocGlobal(CLE_BLOC_MONTAGES, (actuel) => {
    resultat = attribuer(lireMontages(actuel), numerosSerie, metier, valeur, par, new Date().toISOString())
    return resultat
  })
  return resultat ?? lireMontagesEnregistres()
}
